import { fillArray } from '../utils/array';

export default (state = {}, action = {}) => {
	if (action.type === 'LISTING') {
		if (action.currentPage === -1) {
			return {
				...state,
				[action.listing]: {
					...action.data,
					pagesRequested: [-1],
				},
			};
		}

		const { content, ...restData } = action.data;
		const previousContent = state?.[action.listing]?.content || fillArray(action.currentPage * 10);

		return {
			...state,
			[action.listing]: {
				...restData,
				pagesRequested: action.initial ? [action.currentPage, ...(state?.[action.listing]?.pagesRequested || [])] : [...(state?.[action.listing]?.pagesRequested || []), action.currentPage],
				content: [
					...previousContent.slice(0, (action.currentPage - 1) * 10), // Replace placeholder content if exists
					...content,
					...previousContent.slice(action.currentPage * 10),
				],
			},
		};
	}

	return state;
};
